<template>
  <div>
      <div class="top">
        <div class="w1200">
            <div class="left">
            <div class="logobox">
              <img :src="logo" alt="" @click="indexpage">
            </div>
            <ul class="nav">
                <li>
                    <a href="javascript:;" class="a1">{{language[languagetype].about}}</a>
                    <div class="subnav">
                      <router-link :to="{name:'about'}" class="a2">{{language[languagetype].company}}</router-link>
                      <router-link :to="{name:'service'}" class="a2">{{language[languagetype].service}}</router-link>
                      <router-link :to="{name:'contact'}" class="a2">{{language[languagetype].contact}}</router-link>
                    </div>
                </li>
                <li>
                    <a href="javascript:;" class="a1">{{language[languagetype].onlineservice}}</a>
                    <div class="subnav">
                      <a href="javascript:;" class="a2" @click="trackpagebtn">{{language[languagetype].trackpage}}</a>
                      <a href="javascript:;" class="a2" @click="orderbtn">{{language[languagetype].order}}</a>
                      <a href="javascript:;" class="a2" @click="reportbtn">{{language[languagetype].report}}</a>
                      <a href="javascript:;" class="a2" @click="expressbtn">{{language[languagetype].express}}</a>
                    </div>
                </li>
                <li>
                  <router-link :to="{name:'newslist',params:{id: 1}}" class="a1">{{language[languagetype].news}}</router-link>
                </li>
                <li>
                  <a href="javascript:;" class="a1" @click="downpagepage">{{language[languagetype].downtitle}}</a>
                </li>
            </ul>
        </div>
        <div class="right">
            <div class="select">
              <div class="language">{{language[languagetype].lang}}</div>
              <ul class="languagelist">
                <li><a href="javascript:;" @click="changelanguage(1)">中文</a></li>
                <li><a href="javascript:;" @click="changelanguage(2)">English</a></li>
              </ul>
            </div>
            <div class="loginbtn" @click="loginpage" v-if="username==null">
              {{language[languagetype].login}}
            </div>
            <div class="logins" v-if="username!=null">
              {{username.userName}} <span @click="toforget">{{language[languagetype].password}}</span> <span @click="zhuxiao">{{language[languagetype].quit}}</span>
            </div>
        </div>
        </div>
      </div>
      <div class="banner">
          <div class="swiper-container">
            <div class="swiper-wrapper">
                <div class="swiper-slide" v-for="(banner,index) in banners" :key="index"  :style="{background:'#fff url('+ banner.image +') center 0 no-repeat'}">
                    <div class="title">{{banner.title}}</div>
                    <div class="subtitle">{{banner.sub_title}}</div>
                </div>
            </div>
            <!-- 如果需要分页器 -->
            <div class="swiper-pagination"></div>
        </div>
        <div class="trackbox">
            <h1>{{language[languagetype].trackpage}}</h1>
            <input type="text" :placeholder="language[languagetype].casenumber" v-model="casenumber">
            <div class="formbtn" @click="trackbtn">{{language[languagetype].trackpage}}</div>
        </div>
      </div>
      <div class="box1">
          <div class="w1200">
              <div class="box1bg">
                  <div class="searchbox">
                      <div class="searchbox-top">
                        <h1 class="icon1">{{language[languagetype].advance}}</h1>
                        <div class="postition">
                          <input type="text" :placeholder="language[languagetype].errtime" @click="xiala()" v-model="date" readonly>
                          <div :style="{ left: boxleft +'px'}" class="calendarwrap">
                            <calendarbox ref="boxshow" v-on:plandatastartfunc='texta'></calendarbox>
                          </div>
                        </div>
                      </div>
                      <div class="inputbox">
                          <select v-model="advancestart">
                            <option value="">{{language[languagetype].pleaqyg}}</option>
                            <option value="1">宁波(NINGBO)</option>
                          </select>
                          <div></div>
                          <select v-model="advancesend">
                            <option value="">{{language[languagetype].pleamdg}}</option>
                            <option value="24">澳大利亚(AU)</option>
                            <option value="32">美国(UT)</option>
                            <option value="34">美国(TN)</option>
                            <option value="15">新加坡(SG)</option>
                            <option value="17">菲律宾(PH)</option>
                            <option value="44">英国(UK)</option>
                            <option value="25">波兰铁路(EU)</option>
                            <option value="42">波兰海运(EU)</option>
                            <option value="30">印度尼西亚(ID)</option>
                            <option value="20">马来西亚(MY)</option>
                            <option value="10">韩国(KR)</option>
                            <option value="14">日本(JP)</option>
                            <option value="22">泰国(TH)</option>
                          </select>
                      </div>
                      <div class="formbtn amn3" @click="advancebtn">
                        {{language[languagetype].search}}
                      </div>
                  </div>
                  <div class="searchbox">
                      <h1 class="icon2">{{language[languagetype].express}}</h1>
                      <div class="inputbox">
                      </div>
                      <div class="formbtn amn3" @click="expressbtn">
                          {{language[languagetype].search}}
                      </div>
                  </div>
                  <div class="searchbox searchbox1">
                      <h1 class="icon3">{{language[languagetype].order}}</h1>
                      <div class="inputbox">
                      </div>
                      <div class="formbtn amn3" @click="orderbtn">
                          {{language[languagetype].search}}
                      </div>
                  </div>
              </div>
          </div>
      </div>
      <div class="box2">
          <div class="w1200">
              <div class="box2-cont1">
                  <div class="left">
                      <h1>{{serve.title}}</h1>
                      <span v-html='serve.content'></span>
                  </div>
                  <div class="right">
                      <img :src="serve.image" alt="" class="amn3">
                  </div>
              </div>
              <ul class="box2list">
                  <li v-for="(service,index) in services" :key="index" class="flipInX wow" data-wow-duration="1.3s" :data-wow-delay="0.5*index+'s'" >
                      <a href="javascript:;">
                          <div class="picbox"><img :src="service.image" alt=""></div>
                          <div class="cont">
                              <h1>{{service.title}}</h1>
                              <span>{{service.describe}}</span>
                          </div>
                      </a>
                  </li>
              </ul>
              <router-link :to="{name:'service'}" class="formbtn amn3">{{language[languagetype].more}}</router-link>
          </div>
      </div>
      <div class="box3">
          <div class="w1200">
              <div class="box3titletop">
                <div class="box3title">{{language[languagetype].news}}</div>
                <div class="box3nav">
                  <span v-for="index in newsnavlength" :key='index' :class="{s:newsindex===index}" @click="move(index)"></span>
                </div>
              </div>
              <div class="newsbrand">
                <ul class="newslist" :style="{width:1210*newsnavlength+'px',left:-1208*(newsindex-1)+'px'}">
                    <li v-for="(newsa,index) in news" :key="index" class="bounceInUp wow" data-wow-duration="1s" :data-wow-delay="0.3*index+'s'" >
                        <router-link v-bind:to="{name:'newspage',params:{id:newsa.id}}">
                            <div class="picbox">
                              <img :src="newsa.image == null ? defaultpicture : newsa.image">
                            </div>
                            <div class="cont">
                                <span>{{newsa.title}}</span>
                            </div>
                        </router-link>
                    </li>
                </ul>
              </div>
              <router-link :to="{name:'newslist',params:{id: 1}}" class="formbtn amn3">{{language[languagetype].more}}</router-link>
          </div>
      </div>
      <div class="box4">
          <a href="javascript:;" class="btnleft" @click="friendleft"></a>
          <div class="w1200">
              <div class="brand">
                  <ul class="friendlist amn3" :style="{left: friendindex*-202+'px',width: 202*friendlogos.length+'px'}">
                    <li v-for="(friendlogo,index) in friendlogos" :key="index">
                      <a :href="friendlogo.url === '' ? 'javascript:;' : friendlogo.url" :target="friendlogo.url === '' ? '_self' : '_blank'">
                        <img :src="friendlogo.image" alt="">
                        <div class="block">
                          {{friendlogo.title}}
                        </div>
                      </a>
                    </li>
                </ul>
              </div>
          </div>
          <a href="javascript:;" class="btnright" @click="friendright"></a>
      </div>
      <toast ref="toasttext"></toast>
      <div class="wrapbg" v-if="wrapshow">
        <div class="wrap">
          <div class="wrap-title">
            <div class="title">{{language[languagetype].fjf}}</div>
            <div class="close" @click="close"></div>
          </div>
          <div class="warp-cont">
            <div>
              <h1>{{language[languagetype].hc}}</h1>
              <span class="sp1">{{dateday}}{{language[languagetype].day}}</span>
            </div>
            <span class="sp2">{{language[languagetype].lasttime}}：{{lastdate}}</span>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
import Swiper from 'swiper'
import Fetch from '../js/ajaxa'
import 'swiper/css/swiper.min.css'
import calendarbox from '../components/calendar/calendar'
import toast from '../components/taast/toast'
import {WOW} from 'wowjs'
let languagetext = require('../js/index.json')

export default {
  name: 'index',
  data () {
    return {
      banners: [],
      logo: '',
      serve: {
        title: '',
        content: '',
        image: ''
      },
      services: [],
      defaultpicture: '',
      news: [],
      newsindex: 1,
      newsnavlength: 0,
      friendlogos: [
      ],
      friendindex: 0,
      advancestart: '',
      advancesend: '',
      expressnumber: '',
      username: '',
      businessno: '',
      casenumber: '',
      lang: 1,
      language: {},
      languagetype: 'cn',
      boxleft: 0,
      date: '',
      dateday: '',
      lastdate: '',
      wrapshow: false
    }
  },
  mounted () {
    var myswiper = new Swiper('.swiper-container', {// eslint-disable-line no-unused-vars
      effect: 'fade',
      autoplay: {
        disableOnInteraction: false,
        delay: 2500
      },
      loop: true,
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      },
      observer: true,
      observeParents: true
    })
  },
  methods: {
    indexpage: function () {
      this.$router.push({name: 'index'})
    },
    loginpage: function () {
      this.$router.push({name: 'login'})
    },
    toforget: function () {
      this.$router.push({name: 'forget'})
    },
    downpagepage: function () {
      const that = this
      if (that.username == null) {
        setTimeout(function () {
          that.$refs.toasttext.show(that.language[that.languagetype].islogin)
        }, 300)
        setTimeout(function () {
          that.$router.push({name: 'login'})
        }, 1000)
        return false
      }
      this.$router.push({name: 'download'})
    },
    reportbtn: function () {
      const that = this
      if (that.username == null) {
        setTimeout(function () {
          that.$refs.toasttext.show(that.language[that.languagetype].islogin)
        }, 300)
        setTimeout(function () {
          that.$router.push({name: 'login'})
        }, 1000)
        return false
      }
      this.$router.push({name: 'report'})
    },
    expressbtn: function () {
      const that = this
      if (that.username == null) {
        setTimeout(function () {
          that.$refs.toasttext.show(that.language[that.languagetype].islogin)
        }, 300)
        setTimeout(function () {
          that.$router.push({name: 'login'})
        }, 1000)
        return false
      }
      this.$router.push({name: 'express'})
    },
    trackpagebtn: function () {
      const that = this
      if (that.username == null) {
        setTimeout(function () {
          that.$refs.toasttext.show(that.language[that.languagetype].islogin)
        }, 300)
        setTimeout(function () {
          that.$router.push({name: 'login'})
        }, 1000)
        return false
      }
      this.$router.push({name: 'trackpage'})
    },
    orderbtn: function () {
      const that = this
      if (that.username == null) {
        setTimeout(function () {
          that.$refs.toasttext.show(that.language[that.languagetype].islogin)
        }, 300)
        setTimeout(function () {
          that.$router.push({name: 'login'})
        }, 1000)
        return false
      }
      this.$router.push({name: 'order'})
    },
    friendleft: function () {
      this.friendindex--
      if (this.friendindex <= 0) {
        this.friendindex = 0
      }
    },
    friendright: function () {
      if (this.friendindex + 1 > this.friendlogos.length - 6) {
        return false
      }
      this.friendindex++
      if (this.friendindex > this.friendlogos.length - 6) {
        this.friendindex = this.friendlogos.length - 6
      }
    },
    zhuxiao: function () {
      localStorage.removeItem('username')
      location.reload()
    },
    trackbtn: function () {
      const that = this
      if (that.username == null) {
        setTimeout(function () {
          that.$refs.toasttext.show(that.language[that.languagetype].islogin)
        }, 300)
        setTimeout(function () {
          that.$router.push({name: 'login'})
        }, 1000)
        return false
      }
      if (this.casenumber === '') {
        that.$refs.toasttext.show(that.language[that.languagetype].pnno)
        return false
      }
      this.$router.push({name: 'trackpage', params: { bno: that.casenumber }})
    },
    changelanguage: function (id) {
      sessionStorage.setItem('lang', id)
      this.$router.go(0)
    },
    move: function (num) {
      this.newsindex = num
    },
    advancebtn: function () {
      const that = this
      if (this.advancestart === '') {
        that.$refs.toasttext.show(that.language[that.languagetype].errqyg)
        return false
      }
      if (this.advancesend === '') {
        that.$refs.toasttext.show(that.language[that.languagetype].errmdg)
        return false
      }
      if (this.date === '') {
        that.$refs.toasttext.show(that.language[that.languagetype].errtime)
        return false
      }
      var date1 = new Date(this.date).getTime()
      var date2 = date1 - this.advancesend * 24 * 60 * 60 * 1000
      that.dateday = that.advancesend
      that.lastdate = that.formatDate(new Date(date2))
      that.wrapshow = true
    },
    xiala: function () {
      this.$refs.boxshow.show(1)
    },
    texta: function (data) {
      this.date = data.replace(/\//g, '-')
    },
    formatDate: function (date) {
      var y = date.getFullYear()
      var m = date.getMonth() + 1
      m = m < 10 ? '0' + m : m
      var d = date.getDate()
      d = d < 10 ? ('0' + d) : d
      return y + '-' + m + '-' + d
    },
    close: function () {
      this.wrapshow = false
    }
  },
  created () {
    const that = this
    that.language = languagetext
    that.username = JSON.parse(localStorage.getItem('username'))
    var getlang = navigator.language || navigator.userLanguage
    getlang = getlang.substr(0, 2)
    if (getlang === 'zh') {
      sessionStorage.setItem('lang', 1)
    } else {
      sessionStorage.setItem('lang', 2)
    }
    console.log(sessionStorage.getItem('lang'))
    that.lang = sessionStorage.getItem('lang') || 1
    // eslint-disable-next-line
    if (that.lang != 1) {
      that.languagetype = 'en'
    }
  },
  beforeCreate () {
    const that = this
    Fetch.post('Api/config', {
    }).then((res) => {
      that.logo = res.image
    }).catch(err => {
      console.log(err)
    })
    Fetch.post('Api/index', {
    }).then((res) => {
      that.banners = res.banner
      that.serve = res.serve
      that.services = res.service
      that.newsnavlength = Math.ceil(res.news.length / 4)
      that.news = res.news
      that.friendlogos = res.partner
    }).catch(err => {
      console.log(err)
    })
    Fetch.post('Api/newsConfig', {
    }).then((res) => {
      that.defaultpicture = res.image
      setTimeout(function () {
        var wow = new WOW({live: false})
        wow.init()
      }, 100)
    }).catch(err => {
      console.log(err)
    })
  },
  components: {
    toast,
    calendarbox
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .top{position: absolute;top: 0;left: 0;width: 100%;height: 80px;overflow: visible;z-index: 3;}
    .top .left{float: left;}
    .top .w1200{overflow:visible}
    .top .left .logobox{display: block;width: 168px;height: 70px;float: left;display: flex;align-items: center;overflow: hidden;margin-top: 5px;}
    .top .left .logobox img{width: auto;height: auto;max-width: 100%;max-height: 100%;cursor: pointer;}
    .nav{float: left;margin-left: 20px;}
    .nav li{width: auto;min-width: 107px; height: 80px;float: left;position: relative;margin-right: 10px;}
    .nav li .a1{display: block;line-height: 80px;text-align: center;width: 100%;text-decoration: none;color: #fff;font-size: 16px;}
    .nav li .subnav{min-width: 107px;width: auto; height: auto;overflow:visible;background-color: #fff;border-radius: 4px;position: absolute;top: 67px;left: 0;padding: 9px 4px 9px 0;box-sizing: border-box;display: none;}
    .nav li .subnav::before{content: "";position: absolute;top: -5px;left: 53px;display: block;width: 10px;height: 5px;background: url("../assets/jiantou.png") 0 0 no-repeat;}
    .nav li .subnav .a2{display: block;height: 32px;position: relative;text-indent: 32px;line-height: 32px;color: #999999;white-space: nowrap}
    .nav li .subnav .a2::after{content: "";display: block;width: 6px;height: 6px;border-radius: 50%;background-color: #999999;position: absolute;left: 14px;top: 13px;}
    .nav li .subnav .a2:hover{color: #1c5cef;}
    .nav li .subnav .a2:hover::after{background-color: #1c5cef;}
    .nav li:hover .subnav{display: block;}
    .top .right{float: right;}
    .top .right .select{width: 70px;height: 80px;line-height: 80px;font-size: 14px;color: #ffffff;background: url("../assets/xiala.png") right center no-repeat;float: left;position: relative;}
    .top .right .select .language{width: 70px;height: 80px;line-height: 80px;font-size: 14px;color: #ffffff;}
    .top .right .select .languagelist{width: 107px;height: auto;overflow: hidden;display: none;position: absolute;top: 60px;left: 0;background-color: #fff;border-radius: 4px;padding: 9px 0;box-sizing: border-box;}
    .top .right .select .languagelist li{width: 100%;height: 40px;line-height: 40px;}
    .top .right .select .languagelist li a{display: block;text-indent: 10px;text-decoration: none;color: #999999;}
    .top .right .select .languagelist li a:hover{color: #1c5cef;}
    .top .right .select:hover .languagelist{display: block;}
    .top .right .loginbtn{min-width: 95px;height: 80px;line-height: 80px;float: left;margin-left: 37px;font-size: 14px;color: #fff;cursor: pointer;text-indent: 30px;background: url("../assets/user.png") 0 center no-repeat;}
    .top .right .logins{width: auto;height: 80px;line-height: 80px;float: left;margin-left: 37px;font-size: 14px;color: #fff;cursor: pointer;}
    .banner{height: 720px;}
    .banner .title{width: 1200px;height: 59px;line-height: 59px;font-size: 40px;color: #fff;margin: 0 auto;margin-top: 309px;}
    .banner .subtitle{width: 1200px;height: 36px;line-height: 36px;font-size: 16px;color: #fff;margin: 0 auto;}
    .swiper-container{height: 720px;}
    .swiper-container .swiper-slide{background-color: #fff;}
    .swiper-container-fade .swiper-slide-active{background-size: cover !important;}
    .swiper-pagination{bottom: 103px!important;height: 2px;}
    .trackbox{width: 350px;height: 200px;border-radius: 4px;background-color: #fff;float: right;box-sizing: border-box;padding: 0 19px;position: absolute;left: 50%;margin-left: 250px;top: 259px;z-index: 10;}
    .trackbox h1{display: block;width: 100%;height: 30px;margin-top: 14px;line-height: 30px;font-size: 20px;color: #333333;}
    .trackbox input{width: 100%;height: 43px;border: none;border-bottom: 1px solid #999999;text-indent: 31px;background:url("../assets/search.png") 0 center no-repeat;margin-top: 24px;outline: none;}
    .trackbox .formbtn{width: 110px;height: 38px;border-radius: 3px;background-color: #336bed;color: #fff;text-align: center;cursor: pointer;line-height: 38px;margin-top: 25px;}
    .trackbox .formbtn:hover{background-color: #030faa;}
    .box1{height: 200px;margin-top: -73px;position: relative;z-index: 10;}
    .box1 .w1200{overflow: visible;}
    .box1bg{width: 100%;height: 200px;border-radius: 4px;background-color: #fff;box-shadow: 0px 10px 20px 0px rgba(0, 0, 0, 0.1);box-sizing: border-box;padding-left: 24px;}
    .box1bg .searchbox{width: 340px;margin-right: 65px;float: left;height: 200px;overflow: visible;}
    .box1bg .searchbox1{margin-right: 0;}
    .searchbox-top{width: 100%;height: 60px;display: flex;justify-content: space-between;}
    .postition{position: relative;margin-top: 20px;}
    .postition input{width: 150px;height: 40px;border: none;text-indent: 4px;background: url("../assets/riqi_d_t.png") 123px center no-repeat;line-height: 40px;color: #999;font-size: 16px;line-height: 40px;}
    .postition input::placeholder{color: #999;}
    .calendarwrap{position: absolute;top: 45px;}
    .box1bg .searchbox h1{display: block;width: 100%;height: 40px;margin-top: 22px;font-size: 20px;color: #333333;text-indent: 47px;line-height: 40px;}
    .box1bg .searchbox .icon1{background: url("../assets/icon1.png") 0 center no-repeat;}
    .box1bg .searchbox .icon2{background: url("../assets/icon2.png") 0 center no-repeat;}
    .box1bg .searchbox .icon3{background: url("../assets/icon3.png") 0 center no-repeat;}
    .box1bg .searchbox .inputbox{width: 100%;height: 38px;margin-top: 17px;}
    .box1bg .searchbox .inputbox a{color: #999;font-size: 16px;line-height: 37px;}
    .box1bg .searchbox .inputbox input{width: 146px;height: 37px;border:none; border-bottom: 1px solid #999999;color: #999999;font-size: 16px;float: left;outline: none;}
    .box1bg .searchbox .inputbox select{width: 146px;height: 37px;border:none; border-bottom: 1px solid #999999;color: #999999;font-size: 16px;float: left;outline: none;}
    .box1bg .searchbox .inputbox .input{width: 100%;height: 37px;border:none; border-bottom: 1px solid #999999;color: #999999;font-size: 16px;float: left;outline: none;}
    .box1bg .searchbox .inputbox div{width: 48px;height: 38px;float: left;position: relative;}
    .box1bg .searchbox .inputbox div::after{content: "";background-color:#375291;position: absolute;top: 19px;left: 50%;margin-left: -5px;width: 10px;height: 1px;display: block;}
    .box1bg .searchbox .formbtn{width: 110px;height: 38px;border-radius: 3px;background-color: #336bed;color: #fff;text-align: center;cursor: pointer;line-height: 38px;margin-top: 25px;}
    .box1bg .searchbox .formbtn:hover{background-color: #030faa;}
    .box2{height: 790px;overflow: hidden;}
    .box2-cont1{height: 210px;width: 100%;margin-top: 70px;overflow: hidden;}
    .box2-cont1 .left{width: 770px;float: left;height: 100%;}
    .box2-cont1 .left h1{display: block;line-height: 60px;width: 100%;font-size: 40px;color: #333333;}
    .box2-cont1 .left span{display: block;line-height: 30px;margin-top: 14px;color: #333333;font-size: 16px;}
    .box2-cont1 .right{width: 390px;float: right;height: 200px;margin-top: 10px;overflow: hidden;}
    .box2-cont1 .right:hover img{transform: scale(1.2) rotate(3deg);}
    .box2-cont1 .right img{width:390px;height: 200px;object-fit:cover;}
    .box2list{width: 1260px;height: 383px;overflow: hidden;margin-top: 30px;}
    .box2list li{width: 390px;height:375px;float: left;margin-right: 15px;}
    .box2list li:hover{box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.15);}
    .box2list li a{text-decoration: none;color: #333;}
    .box2list li img{width:390px;height: 216px;object-fit:cover;transition:all ease-out .3s 0s;-webkit-transition:all ease-out .3s 0s;-moz-transition:all ease-out .3s 0s;-o-transition:all ease-out .3s 0s;}
    .box2list li .picbox{width: 390px;height: 216px;overflow: hidden;}
    .box2list li:hover img{transform: scale(1.2) rotate(-3deg);}
    .box2list li .cont{width: 100%;height: 159px;box-sizing: border-box;border-bottom: 1px solid #f6f6f6;border-left: 1px solid #f6f6f6;border-right: 1px solid #f6f6f6;padding: 0 20px;overflow: hidden;}
    .box2list li .cont h1{display: block;width: 100%;height: 30px;line-height: 30px;margin-top: 28px;font-size: 20px;}
    .box2list li .cont span{display: block;width: 100%;line-height: 30px;margin-top: 8px;display: -webkit-box; -webkit-box-orient: vertical; -webkit-line-clamp: 3; overflow: hidden;}
    .box2 .formbtn{width: 110px;height: 38px;border-radius: 1px;background-color: #336bed;color: #fff;text-align: center;line-height: 38px;margin-top: 25px;display: block;border-radius: 3px;}
    .box2 .formbtn:hover{background-color: #030faa;}
    .box3{height: 470px;overflow: hidden;}
    .box3titletop{width: 100%;height: 94px;display: flex;align-items: center;justify-content: space-between;}
    .box3title{height: 94px;line-height: 88px;font-size: 40px;color: #333;}
    .box3nav{width: auto;height: 94px;display: flex;align-items: center;}
    .box3nav span{width: 28px;height: 2px;background-color: #E1E1E1;margin-left: 22px;cursor: pointer;}
    .box3nav .s{background-color: #2A3C66;}
    .newsbrand{width: 1200px;height: 291px;overflow: hidden;position: relative;}
    .newslist{min-width:1600px;height: 291px;position: absolute;left: 0;top: 0;transition:all ease-out .3s 0s;-webkit-transition:all ease-out .3s 0s;-moz-transition:all ease-out .3s 0s;-o-transition:all ease-out .3s 0s;}
    .newslist li{width: 290px;height: 280px;overflow: hidden;float: left;margin-right: 12px;}
    .newslist li:hover{box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.15);}
    .newslist li a{text-decoration: none;color: #333;}
    .newslist li .picbox{width: 290px;height: 160px;overflow: hidden;}
    .newslist li img{width: 290px;height: 160px;object-fit:cover;transition:all ease-out .3s 0s;-webkit-transition:all ease-out .3s 0s;-moz-transition:all ease-out .3s 0s;-o-transition:all ease-out .3s 0s;}
    .newslist li:hover .picbox img{transform: scale(1.2)}
    .newslist li .cont{box-sizing: border-box;width: 100%;height: 120px;border-bottom: 1px solid #f6f6f6;border-left: 1px solid #f6f6f6;border-right: 1px solid #f6f6f6;padding: 0 20px;overflow: hidden;}
    .newslist li .cont span{display: block;line-height: 30px;margin-top: 26px;display: -webkit-box; -webkit-box-orient: vertical; -webkit-line-clamp: 2; overflow: hidden;}
    .box3 .formbtn{width: 110px;height: 38px;border-radius: 1px;background-color: #336bed;color: #fff;text-align: center;line-height: 38px;margin-top: 25px;border-radius: 3px; display: block;}
    .box3 .formbtn:hover{background-color: #030faa;}
    .box4{height: 215px;position: relative;}
    .brand{width: 100%;height: 100px;margin-top: 40px;overflow: hidden;position: relative;}
    .friendlist{width: 1240px;height: 100px;position:absolute;left: 0;top: 0;}
    .friendlist li{width: 190px;height: 100px;float: left;margin-right: 12px;position: relative;}
    .friendlist li img{width: 190px;height: 100px;object-fit:cover;}
    .friendlist li a .block{width: 100%;height: 100%;opacity: 0;position: absolute;top: 0;left: 0;background-color: rgba(0, 0, 0, 0.4);color: #fff;display: flex;align-items: center;justify-content: center;}
    .friendlist li a::before{
      content: '';
      position: absolute;
      bottom: 10px;
      top: 10px;
      left: 10px;
      right: 10px;
      z-index: 99;
      transition: all 0.35s;
      border-left: 1px solid #fff;
      border-right: 1px solid #fff;
      transform: scale(1, 0);
    }
    .friendlist li a::after{
      content: '';
      position: absolute;
      bottom: 10px;
      top: 10px;
      left: 10px;
      right: 10px;
      z-index: 99;
      transition: all 0.35s;
      border-top: 1px solid #fff;
      border-bottom: 1px solid #fff;
      transform: scale(0, 1);
    }
    .friendlist li a:hover .block{opacity: 1;}
    .friendlist li a:hover::before{
      transform: scale(1, 1);
    }
    .friendlist li a:hover::after{
      transform: scale(1, 1);
    }
    .btnleft{width: 27px;height: 50px;position: absolute;left: 50%;margin-left: -658px;background: url("../assets/indexleft.png") 0 0 no-repeat;top: 65px;}
    .btnleft:hover{background: url("../assets/indexlefth.png") 0 0 no-repeat;}
    .btnright{width: 27px;height: 50px;position: absolute;left: 50%;margin-left: 630px;background: url("../assets/indexright.png") 0 0 no-repeat;top: 65px;}
    .btnright:hover{background: url("../assets/indexrighth.png") 0 0 no-repeat;}
    .wrapbg{width: 100%;height: 100%;position: fixed;top: 0;left: 0;width: 100%;height: 100%;background-color: rgba(0,0,0,0.4);z-index: 10;}
    .wrap{width: 550px;position: absolute;left: 50%;top: 50%; margin-left: -275px;height: 278px;margin-top: -139px;background-color: #fff;box-sizing: border-box;padding: 0 30px;overflow: hidden;}
    .wrap-title{width: 100%;height: 28px;margin-top: 24px;display: flex;justify-content: space-between;}
    .wrap-title .title{line-height: 28px;font-size: 16px;font-weight: bold;}
    .wrap-title .close{width: 30px;height: 30px;background: url(../assets/close.png) center center no-repeat;cursor: pointer;}
    .warp-cont{width: 300px;height: auto;overflow: hidden;margin: 0 auto;}
    .warp-cont div{width: 300px;height: 103px;overflow: hidden;border-bottom: 1px solid #E9E9E9;}
    .warp-cont h1{display: block;width: 100%;height:27px;margin-top: 17px;line-height: 27px;text-align: center;color: #333333;font-size: 14px;}
    .warp-cont .sp1{display: block;width: 100%;height: 40px;line-height: 40px;color: #1C5CEF;font-size: 40px;text-align: center;font-weight: bold;}
    .warp-cont .sp2{display: block;width: 100%;line-height: 20px;margin-top: 22px;color: #333;text-align: center;}
</style>



// WEBPACK FOOTER //
// src/page/index.vue